export default __webpack_public_path__ + "static/media/1.01f25241.png";